import useSWR from "swr";
import { CORE_API_HOSTNAME } from "../../../env";
import fulfill from "../../../fulfill";
import type { ConfigAccount } from "../../types";

const fetchPayoutConfig = async (payload: {
    accountId: string;
}): Promise<ConfigAccount> => {
    return await fulfill.get({
        accountId: payload.accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${payload.accountId}/payout/config`,
        headers: {
            "Content-Type": "application/json",
        },
        handlers: {
            200: (data) => data,
            404: () => null,
        },
    });
};

export const usePayoutConfig = (accountId: string) => {
    const {
        data: config,
        isLoading: isLoadingConfig,
        error: getConfigError,
    } = useSWR(
        () =>
            accountId
                ? {
                      key: `${accountId}/payout/config`,
                      accountId,
                  }
                : null,
        fetchPayoutConfig,
    );

    return {
        config,
        isLoadingConfig,
        getConfigError,
    };
};
